module.exports = __webpack_public_path__ + "static/media/npa.99706430.png";